import "./LegalInsights.module.css";
import Header from "@/reusable_sections/Header";
import TheBriefing from "./sections/TheBriefing";
import LatestAnalysis from "./sections/LatestAnalysis";
import SubscribeToUpdates from "./sections/SubscribeToUpdates";
import Footer from "@/reusable_sections/Footer";
export default function LegalInsightsPage() {
  return <div>
      <Header />
      <TheBriefing />
      <LatestAnalysis />
      <SubscribeToUpdates />
      <Footer />
    </div>;
}